import { tariffPeriodTranslate } from '../../../util/helpers'
import { Subscription } from '../../../util/promo'
import { KionButton } from '../../button/button'
import s from './styles.module.scss'

export function KionCard(props: {
    subscription: Subscription
    showButton?: boolean
    onSelect?: (val: Subscription) => void
}) {

  function getTariff(): string {
    return tariffPeriodTranslate(props.subscription.tariffPeriod)
  }

  function onButtonClick() {
    props.onSelect?.(props.subscription)
  }

  function transformPrice(price: number) {
    return price / 100
  }

  function fullName() {
	  return props.subscription.name + ' ' + props.subscription.promotion.period;
  }

  return (
    <div 
        style={{ backgroundImage: `url(${props.subscription.image})` }}
        className={s.card}
    >
     <div className={s.age}>
      <span className={s.age__count}>
       { props.subscription.ageRating }
      </span>
     </div>
     <div 
        className={s.card__title}
        dangerouslySetInnerHTML={{__html: fullName()}} 
    />
     <div className={s.card__description}>
      { props.subscription.description }
     </div>
     <div className={s.card__price}>
      <div className={s.main}>
       {transformPrice(props.subscription.discountPrice)}
      </div>
      <div className={s.sub}>
       <div className={s.tariff}>
			₽ за {props.subscription.promotion.timeToLiveValue} мес.
       </div>
       {props.subscription.price !== props.subscription.discountPrice ?
           <div className={s['old-price']}>
                {props.subscription.price / 100} ₽ за {props.subscription.promotion.timeToLiveValue} мес.
            </div>
        :
           <div className={s['old-price']} style={{height: '16px'}}>
           </div>
       }
      </div>

      {props.showButton && (
        <KionButton onClick={onButtonClick}>
          Активировать
        </KionButton>
      )}
     </div>
    </div>
  )
}
